'use client';

import { motion } from 'framer-motion';

type Props = {
  open: boolean;
};
const AnimatedHamburgerMenu = ({ open }: Props) => {
  return (
    <>
      <span className="sr-only">Open main menu</span>
      <motion.div
        animate={open ? 'open' : 'closed'}
        className="flex flex-col space-y-1.5"
        initial="closed"
        variants={{
          open: { rotate: 0, y: 0 },
          closed: { rotate: 0, y: 0 },
        }}
      >
        <motion.div
          animate={open ? { rotate: 45, y: 8 } : { rotate: 0, y: 0 }}
          className="w-6 h-0.5 bg-gray-800"
        />
        <motion.div
          animate={open ? { opacity: 0 } : { opacity: 1 }}
          className="w-6 h-0.5 bg-gray-800"
        />
        <motion.div
          animate={open ? { rotate: -45, y: -8 } : { rotate: 0, y: 0 }}
          className="w-6 h-0.5 bg-gray-800"
        />
      </motion.div>
    </>
  );
};

export default AnimatedHamburgerMenu;
